module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S Duos.633658f6.png";